var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("article", { staticClass: "storefinderResult" }, [
    _c("header", { staticClass: "storefinderResult__header" }, [
      _c(
        "div",
        {
          staticClass: "storefinderResult__company interactive",
          on: { click: _vm.onCompanyClick },
        },
        [
          _vm._v("\n      " + _vm._s(_vm.store.company) + "\n      "),
          _vm.store.isPremium
            ? _c("IconStar", { staticClass: "storefinderResult__premiumIcon" })
            : _vm._e(),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "storefinderResult__distance" }, [
      _vm._v(_vm._s(Number(_vm.store.distance.toFixed(1))) + " km"),
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "storefinderResult__address" }, [
      _vm.store.address
        ? _c("span", [_vm._v(_vm._s(_vm.store.address) + "\n      "), _c("br")])
        : _vm._e(),
      _vm._v(" "),
      _vm.store.zip ? _c("span", [_vm._v(_vm._s(_vm.store.zip))]) : _vm._e(),
      _vm._v(" "),
      _vm.store.city
        ? _c("span", [_vm._v(_vm._s(_vm.store.city) + "\n      "), _c("br")])
        : _vm._e(),
      _vm._v(" "),
      _vm.store.phone
        ? _c("span", [
            _vm._v("\n      " + _vm._s(_vm.staticTextPhone) + ":\n      "),
            _c("a", { attrs: { href: _vm._f("tel")(_vm.store.phone) } }, [
              _vm._v(_vm._s(_vm.store.phone)),
            ]),
            _vm._v(" "),
            _c("br"),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.store.www
        ? _c("span", [
            _vm._v("\n      " + _vm._s(_vm.staticTextWeb) + ":\n      "),
            _c(
              "a",
              {
                attrs: {
                  href: _vm._f("http")(_vm.store.www),
                  target: "_blank",
                },
              },
              [_vm._v(_vm._s(_vm.store.www))]
            ),
            _vm._v(" "),
            _c("br"),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.store.email
        ? _c("span", [
            _vm._v("\n      " + _vm._s(_vm.staticTextEmail) + ":\n      "),
            _c(
              "a",
              {
                attrs: {
                  href: _vm._f("mailto")(_vm.store.email),
                  target: "_blank",
                },
              },
              [_vm._v(_vm._s(_vm.store.email))]
            ),
            _vm._v(" "),
            _c("br"),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "storefinderResult__categoryListWrapper" }, [
      _c(
        "ul",
        { staticClass: "storefinderResult__categoryList" },
        _vm._l(_vm.store.tags, function (tag) {
          return _c(
            "li",
            {
              staticClass: "storefinderResult__categoryListItem",
              attrs: { "data-category": tag.uid },
            },
            [
              tag.image
                ? [
                    _c("img", {
                      staticClass: "storefinderResult__categoryIcon",
                      attrs: {
                        src: tag.image,
                        alt: tag.tagTitle,
                        title: tag.tagTitle,
                      },
                    }),
                  ]
                : [
                    _c("div", {
                      staticClass:
                        "storefinderResult__categoryIcon storefinderResult__categoryIcon--placeholder",
                      attrs: { title: tag.tagTitle },
                    }),
                  ],
            ],
            2
          )
        }),
        0
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "storefinderResult__actions" }, [
      _c(
        "a",
        {
          staticClass: "button storefinder__button storefinder__button--result",
          attrs: { href: _vm._f("directions")(_vm.store), target: "_blank" },
        },
        [_vm._v(_vm._s(_vm.staticTextDirections))]
      ),
      _vm._v(" "),
      _vm.store.email
        ? _c(
            "button",
            {
              staticClass: "storefinder__button storefinder__button--result",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.$emit("contact", _vm.store)
                },
              },
            },
            [_vm._v(_vm._s(_vm.staticTextContactButton))]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }